module.exports = {
  GuideMultiInput: {
    PluginName: "Ekran Eğitimi Çoklu Giriş",
    EmptyHint: "Ekran Eğitimi Çoklu Giriş alanı — araç çubuğundan öğe ekleyin",
    Items: "Öğeler",
    ItemCount: "Öğe Sayısı",
    placeholder: "Buraya yazın…",
    add_tag: "Etiket Ekle",
    kind_tag: "Etiket",
    tag_ref: "Etiket Referansı",
    tag_ref_placeholder: "örn. isim",
    behavior_title: "Davranış",
    auto_advance: "Tüm adımlar bitince sahneyi ilerlet",
    cue_beacon: "Aktif adımda yanıp sönen vurgu",
    cue_cursor: "İmleç aktif adıma gitsin",
    cue_backdrop: "Aktif adım dışını karart",
    zoom_enabled: "Aktif adıma yakınlaş",
  },
};
